import React, { useEffect, useMemo, useState } from "react";
import MDBox from "components/MDBox";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Card,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";

import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Footer from "examples/Footer";
import IconButton from "@mui/material/IconButton";
import ApiCalls from "services/flick_erp_api_call";
import {
  AccountCircle,
  Cancel,
  Check,
  Groups3,
  AccessTime,
  AddCircleOutline,
  SearchRounded,
  WorkOutline,
	Schema,
} from "@mui/icons-material";
import { advertisementLists } from "./jobAdvertisementSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import MDAlert from "components/MDAlert";
import { TextField } from "@mui/material";
import { TextViewEditorBox } from "components/TextViewEditorBox";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import './position.css';
import { useTheme } from "@emotion/react";
import Position from "./position";
import { hiringFlowLists } from "../setting/settingSlice";
import DeleteIcon from "@mui/icons-material/Delete";
import { employeeList } from "layouts/employees/employeesSlice";
import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";
import { CreateOpeningDialog } from "./CreateOpeningsDialog";

const createDefaultJobAdvertisementPayload = (user) => ({
  id: "",
  position: "",
  education: "",
  experience: "",
  vacancy: "",
  description: "",
  created_by: user?.employee_id,
  deadline: new Date(),
  post_date: new Date(),
  type: "create",
  hiring_stage: [],
  show_salary: false,
  min_ctc: "",
  max_ctc: "",
});

const normalizeHiringFlowSelection = (flow) => {
  if (!flow) {
    return { flowId: null, flowTypes: [] };
  }

  return {
    flowId: flow.id || null,
    flowTypes: flow.flow_types || [],
  };
};

function CurrentOpenings({ modulePermissions, permissions }) {
  const user = JSON.parse(localStorage.getItem("user"));
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const surfaceColor = isDarkMode ? theme.palette.background.paper : colors.light.main;
  const mutedSurfaceColor = isDarkMode ? theme.palette.background.default : colors.background.accent;
  const borderColor = isDarkMode ? theme.palette.divider : `${colors.secondary.main}18`;
  const [descriptionDialog, setDescriptionDialog] = useState(false);
  const [
    createORUpdateJobAdvertisementDialog,
    setCreateORUpdateJobAdvertisementDialog,
  ] = useState(false);

  // const { size } = typography;
  function createData(
    id,
    position,
    education,
    experience,
    vacancy,
    description,
    deadline,
    post_date
  ) {
    return {
      id,
      position,
      education,
      experience,
      vacancy,
      description,
      deadline,
      post_date,
    };
  }

  //useState hooks
  var newIndex;

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [data, setData] = useState([]);

  const [editableRowIndex, setEditableRowIndex] = useState(null);
  const [editedData, setEditedData] = useState([]);
  const [id_, setID] = useState();
  const date = new Date();

  const [positionError, setPositionError] = useState("");
  const [educationError, setEducationError] = useState("");
  const [vacancyError, setVacancyError] = useState("");
  const [experienceError, setExperienceError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [deadlineError, setDeadlineError] = useState("");
  const [selectedHiringFlow, setSelectedHiringFlow] = useState(null);
  const [hiringId, setHiringId] = useState(null);
  const [changeHiringFlowPopup, setChangeHiringFlowPopup] = useState(false);
  const [isCard, setIsCard] = useState(false)
  const [searchValue, setSearchValue] = useState("");
  const [formError, setFormError] = useState("");

  const initialFormattedDate = date;
  const [jobAdvertisementPayload, setJobAdvertisementPayload] = useState(
    createDefaultJobAdvertisementPayload(user)
  );


  useEffect(() => {
    hiring();
    // hiringFlowSubStages();
  }, []);

	
  async function hiring() {
    const res = await ApiCalls.getNewHiringFlow();
    if (res.success && res.code === 200) {
      // setStageData(res.data);
      dispatch(hiringFlowLists({ hiring: res.data }));
    } else {
    }
  }

  // Function to handle item click
  const handleSelectHiringFlow = (name) => {
    const { flowId, flowTypes } = normalizeHiringFlowSelection(name);
    setSelectedHiringFlow(flowTypes);
    setHiringId(flowId);
    setChangeHiringFlowPopup(false);
  };
  const handleOpenHiringFlow = () => {
    setChangeHiringFlowPopup(true);
  }
  const handleCloseHiringFlow = () => {
    setChangeHiringFlowPopup(false);
  }

  const dispatch = useDispatch();
  const navigate = useNavigate();

  //api for delete job advertisement

  const handleDeleteClick = async (row) => {
    const recordId = row.id;
    const res = await ApiCalls.deleteAdvertisement(recordId);

    if (res.success && res.code === 204) {
      jobAdvertisement();
    } else {
    }
  };

  useEffect(() => {
    permissions.includes(modulePermissions.jobAdvertisement.list_permission) && jobAdvertisement();
    getEmployee(`?status=${status.val}`);
  }, []);

  // Api for get Job Advertisement List
  async function jobAdvertisement() {
    const res = await ApiCalls.getAdvertisementList();
    if (res.success && res.code === 200) {
      setData(res.data);
      dispatch(advertisementLists({ jobAdvertisement: res.data }));
    } else {
    }
  }

  const [employeesData, setEmployeesData] = useState({
          columns: [
              { Header: "Emp ID", accessor: "emp_id", width: "10%" },
              {
                  Header: "Name",
                  accessor: "firstname",
                  Cell: ({ row }) => (
                      <div style={{ display: "flex", alignItems: "center" }}>
                          <Avatar alt="Profile Photo">
                              {row.original.profilePhoto.length > 0 ? (
                                  <img
                                      src={row.original.profilePhoto}
                                      style={{
                                          width: "50px",
                                          height: "50px",
                                          objectFit: "cover",
                                          borderRadius: "50%",
                                      }}
                                  />
                              ) : (
                                  row.original.firstname.charAt(0).toUpperCase()
                              )}
                          </Avatar>
                          <span style={{ marginLeft: "0.5rem" }}>
                              {row.original.firstname}
                          </span>
                          <span style={{ marginLeft: "0.2rem" }}>
                              {row.original.lastname}
                          </span>
                      </div>
                  ),
              },
              { Header: "Designation", accessor: "designation" },
  
              { Header: "email", accessor: "email" },
              { Header: "manager", accessor: "manager_name" },
              { Header: "Date of joining", accessor: "doj" },
          ],
          rows: [],
      });

  // Api for create job advertisement
  const [showAlert, setShowAlert] = useState(null);
  const alertContent = (name) => (
    <MDTypography variant="body2" color="white">
      {name}
    </MDTypography>
  );
  const clearValidation = () => {
    setPositionError("");
    setVacancyError("");
    setDeadlineError("");
    setEducationError("");
    setDescriptionError("");
    setExperienceError("");
    setFormError("");
  };

  const validateJobAdvertisementPayload = () => {
    let hasError = false;
    const error = "This field may not be blank.";

    if (!jobAdvertisementPayload.position?.trim()) {
      setPositionError(error);
      hasError = true;
    } else {
      setPositionError("");
    }

    if (!jobAdvertisementPayload.education?.trim()) {
      setEducationError(error);
      hasError = true;
    } else {
      setEducationError("");
    }

    if (jobAdvertisementPayload.vacancy === "" || jobAdvertisementPayload.vacancy === undefined) {
      setVacancyError(error);
      hasError = true;
    } else {
      setVacancyError("");
    }

    if (jobAdvertisementPayload.experience === "" || jobAdvertisementPayload.experience === undefined) {
      setExperienceError(error);
      hasError = true;
    } else {
      setExperienceError("");
    }

    if (!jobAdvertisementPayload.description?.trim()) {
      setDescriptionError(error);
      hasError = true;
    } else {
      setDescriptionError("");
    }

    if (!jobAdvertisementPayload.deadline) {
      setDeadlineError(error);
      hasError = true;
    } else {
      setDeadlineError("");
    }

    if (!hiringId) {
      setFormError("Please select a hiring flow before continuing.");
      hasError = true;
    } else {
      setFormError("");
    }

    if (jobAdvertisementPayload.show_salary) {
      const minCTC = Number(jobAdvertisementPayload.min_ctc);
      const maxCTC = Number(jobAdvertisementPayload.max_ctc);

      if (!minCTC || !maxCTC || minCTC > maxCTC) {
        setFormError("Provide a valid salary range when salary visibility is enabled.");
        hasError = true;
      }
    }

    return !hasError;
  };

  const buildJobAdvertisementPayload = () => ({
    position: jobAdvertisementPayload.position.trim(),
    education: jobAdvertisementPayload.education.trim(),
    experience: Number(jobAdvertisementPayload.experience),
    vacancy: Number(jobAdvertisementPayload.vacancy),
    description: jobAdvertisementPayload.description,
    deadline: moment(jobAdvertisementPayload.deadline).format("YYYY-MM-DD"),
    post_date: moment(jobAdvertisementPayload.post_date).format("YYYY-MM-DD"),
    hiring_stage: hiringId,
    created_by: user.employee_id,
    show_salary: jobAdvertisementPayload.show_salary,
    min_ctc: jobAdvertisementPayload.show_salary ? Number(jobAdvertisementPayload.min_ctc) : null,
    max_ctc: jobAdvertisementPayload.show_salary ? Number(jobAdvertisementPayload.max_ctc) : null,
  });

  const handleAddRecord = async () => {
    if (!validateJobAdvertisementPayload()) {
      return;
    }

    const res = await ApiCalls.createAdvertisement(buildJobAdvertisementPayload());
    if (res.success && res.code == 201) {
      jobAdvertisement();
      setCreateORUpdateJobAdvertisementDialog(false);
      setJobAdvertisementPayload(createDefaultJobAdvertisementPayload(user));
      setSelectedHiringFlow([]);
      setHiringId(null);
    }
  };

  const handleCancelRecord = () => {
    setShowAlert(null);
  };

  // Api for update job advertisement

  // const handleEditClick = (row, actualIndex) => {
  //   setEditableRowIndex(actualIndex);
  //   setEditedData([...data]);
  //   setID(row.id);
  // };

  const handleSaveClick = async () => {
    if (!validateJobAdvertisementPayload()) {
      return;
    }

    const data = buildJobAdvertisementPayload();
    const res = await ApiCalls.updateJobAdvertisement(
      jobAdvertisementPayload.id,
      data
    );
    if (res.success && res.code == 200) {
      jobAdvertisement();
      setCreateORUpdateJobAdvertisementDialog(false);
      setJobAdvertisementPayload(createDefaultJobAdvertisementPayload(user));
      setSelectedHiringFlow([]);
      setHiringId(null);
    } else {
    }
  };

  const handleFieldChange = (event, fieldName) => {
    const updatedData = [...editedData];
    const editedRecord = { ...updatedData[editableRowIndex] };
    editedRecord[fieldName] = event.target.value;
    updatedData[editableRowIndex] = editedRecord;
    setEditedData(updatedData);
  };

  // useSelector Hook
  const advertisements = useSelector(
    (state) => state.jobAdvertisement.jobAdvertisement
  );

  const [positionData, setPositionData] = useState({})
  const description = useSelector((state) => state.textViewBox.value);
  useEffect(() => {
    if (description != "") {
      const updatedData = [...editedData];

      const editedRecord = { ...updatedData[editableRowIndex] };
      editedRecord["description"] = description;
      updatedData[editableRowIndex] = editedRecord;
      setEditedData(updatedData);
    }
  }, [description]);

  const HiringFlowList = useSelector((state) => state.hiring.hiring);

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleDeletePosition = async (e, id) => {
		e.stopPropagation();
    const res = await ApiCalls.deleteAdvertisement(id);
    if (res.success && res.code === 204) {
      jobAdvertisement();
    } else {
    }
  }

  async function getEmployee() {
      const user = JSON.parse(localStorage.getItem("user"));
      var res = await ApiCalls.getBaseEmployeesList("?status=active");
      if (res.success && res.code === 200) {
          dispatch(employeeList({ employee: res.data }));
          var data = JSON.parse(JSON.stringify(res.data));
          // Assuming 'data' is your object
          // localStorage.setItem("Employee_Data", JSON.stringify(data));

          var filterData = data.filter((o) => (o.user.id = o.id));
          employeesData.rows = filterData.map((o) => ({
              ...o.user,
              emp_id: o?.emp_id,
              designation: o?.designation?.name,
              doj: o?.doj,
              profilePhoto: o?.img || AccountCircle,
              manager_name: o?.manager_name
          }));
          // dispatch(employeeList({ employee: employeesData }));
          setEmployeesData({ ...employeesData });
      } else {
      }
  }

  const filteredAdvertisements = useMemo(() => {
    const list = advertisements || [];
    if (!searchValue.trim()) return list;
    const query = searchValue.toLowerCase();

    return list.filter((ad) => {
      const fields = [
        ad?.position,
        ad?.education,
        ad?.experience?.toString?.(),
        ad?.vacancy?.toString?.(),
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return fields.includes(query);
    });
  }, [advertisements, searchValue]);

  const openingStats = useMemo(() => {
    const list = advertisements || [];
    return {
      total: list.length,
      active: list.filter((item) => item.is_active).length,
      closed: list.filter((item) => item.is_active === false).length,
      totalVacancies: list.reduce((sum, item) => sum + Number(item?.vacancy || 0), 0),
    };
  }, [advertisements]);

	const handleCloseCreateOpeningDialog = () => {
		setJobAdvertisementPayload(createDefaultJobAdvertisementPayload(user));
    setSelectedHiringFlow([]);
    setHiringId(null);
		setCreateORUpdateJobAdvertisementDialog(false);
		clearValidation();
	}

	const renderCreateOpeningDialog = () => {
      return ( 
				<CreateOpeningDialog 
				    openDialog = {createORUpdateJobAdvertisementDialog}
				    closeDialog = {handleCloseCreateOpeningDialog}
						isSmallScreen={isSmallScreen}
						selectedHiringFlow = {selectedHiringFlow}
						handleOpenHiringFlow = {handleOpenHiringFlow}
						permissions = {permissions}
						modulePermissions = {modulePermissions}
						jobAdvertisementPayload = {jobAdvertisementPayload}
						setJobAdvertisementPayload = {setJobAdvertisementPayload}
						handleAddRecord = {handleAddRecord}
						handleSaveClick = {handleSaveClick}
            formError = {formError}
				/>
			)
	}

  return (
    <>
      {/* <DashboardLayout>
      <DashboardNavbar /> */}
      {!isCard ? (
        <MDBox>
          <MDBox mb={2}>
            {showAlert && (
              <MDAlert
                color="primary"
                dismissible
                onClick={() => {
                  setShowAlert(null);
                }}
              >
                {alertContent(showAlert)}
              </MDAlert>
            )}
          </MDBox>

          {/*<Card
            sx={{
              p: { xs: 2, md: 2.5 },
              borderRadius: "30px",
              border: `1px solid ${colors.secondary.main}1a`,
              boxShadow: "0 18px 42px rgba(15, 23, 42, 0.08)",
              mb: 3,
            }}
          >*/}
					<MDBox
            m={2}
            sx={{
              p: { xs: 2, md: 2.5 },
              borderRadius: "30px",
              border: `1px solid ${borderColor}`,
              background: isDarkMode
                ? "linear-gradient(160deg, rgba(30,41,59,0.95), rgba(15,23,42,0.9))"
                : "linear-gradient(145deg, rgba(255,255,255,0.98), rgba(245,247,255,0.98))",
              boxShadow: isDarkMode
                ? "0 20px 44px rgba(2, 6, 23, 0.34)"
                : "0 24px 48px rgba(15, 23, 42, 0.08)",
            }}
          >
            <Grid container spacing={2.5} alignItems="center">
              <Grid item xs={12} lg={7}>
                <MDTypography variant="h4" sx={{ letterSpacing: "-0.04em", fontWeight: 700 }}>
                  Current Openings
                </MDTypography>
                <MDTypography variant="body2" color="text" sx={{ mt: 0.9, maxWidth: 620, lineHeight: 1.7 }}>
                  Manage active roles, review hiring demand, and open new requisitions from one cleaner hiring workspace.
                </MDTypography>
              </Grid>
              <Grid item xs={12} lg={5} sx={{display:"flex", justifyContent : "end", gap:1}}>

								 {permissions.includes(modulePermissions.jobAdvertisement.create_permission) && (
									<>
										<MDButton
											variant="gradient"
											color="info"
											startIcon={<AddCircleOutline />}
											sx={{ borderRadius: "14px", px: 2.5, width: { xs: "100%", md: "auto" } }}
											onClick={() => {
												setJobAdvertisementPayload(createDefaultJobAdvertisementPayload(user));
                        setSelectedHiringFlow([]);
                        setHiringId(null);
                        clearValidation();
                        setCreateORUpdateJobAdvertisementDialog(true);
                      }}
                    >
                      Create Opening
                    </MDButton>

										<MDButton 
										  variant= "gradient"
											color = 'info'
											startIcon={<Schema />}
											sx={{ borderRadius: "14px", px: 2.5, width: { xs: "100%", md: "auto" } }}
											onClick = {() => {
												navigate('/recruitement/hiring_flows')
											}}
										>
											View Hiring Flows
										</MDButton>
									</>
                  )}

               
              </Grid>
							 <Grid container spacing={2} p={2}>
                  {[
                    {
                      label: "Open Roles",
                      value: openingStats.total,
                      tone: colors.info.main,
                      icon: <WorkOutline sx={{ color: colors.info.main, fontSize: 19 }} />,
                    },
                    {
                      label: "Active",
                      value: openingStats.active,
                      tone: colors.success.main,
                      icon: <Check sx={{ color: colors.success.main, fontSize: 19 }} />,
                    },
                    {
                      label: "Closed",
                      value: openingStats.closed,
                      tone: colors.error.main,
                      icon: <Cancel sx={{ color: colors.error.main, fontSize: 19 }} />,
                    },
                    {
                      label: "Vacancies",
                      value: openingStats.totalVacancies,
                      tone: colors.warning.focus,
                      icon: <Groups3 sx={{ color: colors.warning.focus, fontSize: 19 }} />,
                    },
                  ].map((stat) => (
                    <Grid item xs={12} sm={6} lg={3} key={stat.label}>
                      <Box
                        sx={{
                          p: 1.75,
                          borderRadius: "22px",
                          background: isDarkMode
                            ? `linear-gradient(135deg, ${rgba(stat.tone, 0.2)} 0%, rgba(15,23,42,0.72) 100%)`
                            : `linear-gradient(135deg, ${rgba(colors.primary.main, 0.98)} 0%, ${rgba(colors.info.focus, 0.95)} 55%, ${rgba(colors.info.main, 0.88)} 100%)`,
                          border: `1px solid ${rgba(stat.tone, isDarkMode ? 0.28 : 0.14)}`,
                        }}
                      >
                        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                          <Box>
                            <Typography sx={{ fontSize: "0.74rem", fontWeight: 700, color: colors.light.main, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                              {stat.label}
                            </Typography>
                            <Typography sx={{ fontSize: "1.55rem", fontWeight: 700, color: colors.light.main, mt: 0.8 }}>
                              {stat.value}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              width: 36,
                              height: 36,
                              borderRadius: "12px",
                              backgroundColor: isDarkMode ? "rgba(255,255,255,0.14)" : "rgba(255,255,255,0.7)",
                              display: "grid",
                              placeItems: "center",
                            }}
                          >
                            {stat.icon}
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
            </Grid>
          

          {/*<Card
            sx={{
              p: { xs: 2, md: 2.25 },
              borderRadius: "28px",
              border: `1px solid ${colors.secondary.main}14`,
              boxShadow: "0 14px 36px rgba(15, 23, 42, 0.05)",
              mb: 3,
            }}
          >*/}
            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{
                mt: 1,
                p: 2,
                borderRadius: "22px",
                backgroundColor: mutedSurfaceColor,
                border: `1px solid ${borderColor}`,
              }}
            >
              <Grid item xs={12} md={6} lg={7}>
                <TextField
                  fullWidth
                  size="small"
                  value={searchValue}
                  onChange={(event) => setSearchValue(event.target.value)}
                  placeholder="Search by position, education, experience..."
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "16px",
                      backgroundColor: surfaceColor,
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <SearchRounded sx={{ color: colors.secondary.main, fontSize: 18, mr: 1 }} />
                    ),
                  }}
                />
              </Grid>
              {/*<Grid item xs={12} md={6} lg={5}>
                <Box display="flex" justifyContent={{ xs: "stretch", md: "flex-end" }}>
                  {permissions.includes(modulePermissions.jobAdvertisement.create_permission) && (
                    <MDButton
                      variant="gradient"
                      color="info"
                      startIcon={<AddCircleOutline />}
                      sx={{ borderRadius: "14px", px: 2.5, width: { xs: "100%", md: "auto" } }}
                      onClick={() => {
                        setJobAdvertisementPayload((state) => ({
                          ...state,
                          deadline: new Date(),
                          post_date: new Date(),
                          type: "create",
                        }));
                        setCreateORUpdateJobAdvertisementDialog(true);
                      }}
                    >
                      Create Opening
                    </MDButton>
                  )}
                </Box>
              </Grid>*/}
            </Grid>
          {/*</Card>*/}

          <MDBox sx={{ margin: "20px 0" }}>
            <Grid container spacing={2.5}>
              {filteredAdvertisements.map((ad) => (
                <Grid item xs={12} sm={4} key={ad.id}>
                  <Card
                    sx={{
                      p: 2.25,
                      height: "100%",
                      borderRadius: "24px",
                      border: `1px solid ${borderColor}`,
                      background: isDarkMode
                        ? "linear-gradient(180deg, rgba(30,41,59,0.96) 0%, rgba(15,23,42,0.95) 100%)"
                        : "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,255,0.98) 100%)",
                      boxShadow: isDarkMode
                        ? "0 18px 36px rgba(2, 6, 23, 0.28)"
                        : "0 14px 34px rgba(15, 23, 42, 0.05)",
                      transition: "transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease",
                      "&:hover": {
                        transform: "translateY(-3px)",
                        boxShadow: isDarkMode
                          ? "0 24px 48px rgba(2, 6, 23, 0.38)"
                          : "0 22px 44px rgba(15, 23, 42, 0.08)",
                        borderColor: `${colors.info.main}33`,
                      },
											cursor : "pointer"											
                    }}
										onClick={() => {
                          const { flowId, flowTypes } = normalizeHiringFlowSelection(ad?.hiring_stage);
                          setJobAdvertisementPayload((state) => ({
                            ...state,
                            ...ad,
                            type: "update",
                            show_salary: Boolean(ad?.show_salary),
                            min_ctc: ad?.min_ctc ?? "",
                            max_ctc: ad?.max_ctc ?? "",
                          }));
                          setSelectedHiringFlow(flowTypes);
                          setHiringId(flowId);
                          setIsCard(true);
                          clearValidation();
                          setPositionData({ candidates: ad?.candidates_job_openings, screenings: ad.screenings, ad: ad, selectedHiringFlow: flowTypes });
                        }}
                  >
                    <Box sx={{ display: "flex", gap: "16px", position: "relative" }}>
                      <Box>
                        <Avatar
                          alt="Profile Picture"
                          sx={{
                            width: 54,
                            height: 54,
                            backgroundColor: colors.info.main,
                            color: colors.light.main,
                            boxShadow: `0 12px 24px ${rgba(colors.info.main, 0.25)}`,
                          }}
                        >
                          {ad.position?.charAt(0) || "O"}
                        </Avatar>
                      </Box>
											<MDBox sx={{display: 'flex', gap:2}}>
                      <Box sx={{ minWidth: 0 }}>
                        
                        <Typography mt={0.2} sx={{ fontWeight: "600", fontSize: "1.05rem", cursor: "pointer" }}
                          onClick={() => {
                            const { flowId, flowTypes } = normalizeHiringFlowSelection(ad?.hiring_stage);
                            setJobAdvertisementPayload((state) => ({
                              ...state,
                              ...ad,
                              type: "update",
                              show_salary: Boolean(ad?.show_salary),
                              min_ctc: ad?.min_ctc ?? "",
                              max_ctc: ad?.max_ctc ?? "",
                            }));
                            setSelectedHiringFlow(flowTypes);
                            setHiringId(flowId);
                            setIsCard(true)
                            clearValidation();
                            setPositionData({ candidates: ad?.candidates_job_openings, screenings: ad.screenings, ad: ad, selectedHiringFlow: flowTypes })
                            // navigate("/recruitement/position", {
                            //   state: { candidates: ad?.candidates_job_openings, screenings: ad.screenings, ad: ad, selectedHiringFlow: selectedHiringFlow },
                            // })
                          }}
                        // sx={{
                        //   cursor: "pointer",
                        // }}
                        >
                          {ad.position}
                        </Typography>
                        <Typography sx={{ fontSize: "0.82rem", color: isDarkMode ? colors.grey[400] : colors.text.main }}>
                          {ad.education}
                        </Typography>
                      </Box>
												</MDBox>
                      <Box sx={{ position: "absolute", right: "0px", top: "0px" }}>
                        <IconButton
                          sx={{
                            p: 0.75,
                            backgroundColor: `${colors.error.main}10`,
                            color: colors.error.main,
                          }}
                          onClick={(e) => handleDeletePosition(e, ad.id)}
                        >
                          <DeleteIcon color="#CED4DA" />
                        </IconButton>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        borderBottom: `1px solid ${colors.secondary.main}14`,
                        margin: "14px 0",
                        width: '100%',
                        alignSelf: 'center',
                      }}
                    />

                    <Grid container spacing={1.25}>
                      <Grid item xs={6}>
                        <Box
                          sx={{
                            p: 1.2,
                            borderRadius: "16px",
                            background: isDarkMode
                              ? "linear-gradient(235deg, rgba(51,65,85,0.92) 0%, rgba(30,41,59,0.85) 100%)"
                              : `linear-gradient(235deg, ${colors.light.main} 0%, ${colors.background.accent} 40%)`,
                          }}
                        >
                          <Typography sx={{ fontSize: "0.72rem", color: colors.secondary.main, textTransform: "uppercase", fontWeight: 700, letterSpacing: "0.08em" }}>
                            Experience
                          </Typography>
                          <Typography sx={{ fontSize: "0.95rem", color: isDarkMode ? colors.light.main : colors.dark.main, fontWeight: 600, mt: 0.45 }}>
                            {ad.experience} yrs
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Box
                          sx={{
                            p: 1.2,
                            borderRadius: "16px",
                            //backgroundColor: `${colors.background.elevated}`,
														background: isDarkMode
                              ? "linear-gradient(235deg, rgba(51,65,85,0.92) 0%, rgba(30,41,59,0.85) 100%)"
                              : `linear-gradient(235deg, ${colors.light.main} 0%, ${colors.background.accent} 40%)`
                          }}
                        >
                          <Typography sx={{ fontSize: "0.72rem", color: colors.secondary.main, textTransform: "uppercase", fontWeight: 700, letterSpacing: "0.08em" }}>
                            Vacancies
                          </Typography>
                          <Typography sx={{ fontSize: "0.95rem", color: isDarkMode ? colors.light.main : colors.dark.main, fontWeight: 600, mt: 0.45 }}>
                            {ad.vacancy}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>

                    <Box mt={1.6} display="flex" justifyContent="space-between" alignItems="center">
                      <Box display="flex" alignItems="center" gap={0.7}>
                        <AccessTime sx={{ color: colors.secondary.main, fontSize: 16 }} />
                        <Typography sx={{ fontSize: "0.78rem", color: isDarkMode ? colors.grey[400] : colors.text.main }}>
                          Deadline {moment(ad.deadline).format("DD MMM YYYY")}
                        </Typography>
                      </Box>

											<Box display="flex" alignItems="top" gap={1} mt={0.5}>
                          <Chip
                            label={ad.is_active ? "Active" : "Closed"}
                            size="small"
                            sx={{
                              height: 24,
                              backgroundColor: ad.is_active ? `${colors.success.main}14` : `${colors.error.main}14`,
                              color: ad.is_active ? colors.success.main : colors.error.main,
                              fontWeight: 700,
                            }}
                          />
                        </Box>
                      {/*<MDButton
                        size="small"
                        variant="text"
                        color="info"
                        onClick={() => {
                          setJobAdvertisementPayload((state) => ({
                            ...state,
                            ...ad,
                            type: "update",
                          }));
                          setIsCard(true);
                          clearValidation();
                          setPositionData({ candidates: ad?.candidates_job_openings, screenings: ad.screenings, ad: ad, selectedHiringFlow: selectedHiringFlow });
                        }}
                      >
                        View Role
                      </MDButton>*/}
                    </Box>
                  </Card>
                </Grid>
              ))}
              {!filteredAdvertisements.length && (
                <Grid item xs={12}>
                  <Card
                    sx={{
                      p: 5,
                      borderRadius: "24px",
                      textAlign: "center",
                      border: `1px dashed ${colors.secondary.main}40`,
                      backgroundColor: mutedSurfaceColor,
                    }}
                  >
                    <MDTypography variant="h5" sx={{ color: isDarkMode ? colors.light.main : colors.dark.main, mb: 1 }}>
                      No openings found
                    </MDTypography>
                    <MDTypography variant="body2" color="text">
                      Try a different search term or create a new opening.
                    </MDTypography>
                  </Card>
                </Grid>
              )}
            </Grid>
          </MDBox>

					</MDBox>
          {/* <br /> */}
        </MDBox>
      ) : (
        <Position positionData={positionData} setJobAdvertisementPayload={setJobAdvertisementPayload} setIsCard={setIsCard} modulePermissions={modulePermissions} permissions={permissions} />
      )}

      <br />

      {createORUpdateJobAdvertisementDialog && renderCreateOpeningDialog()}

      <Dialog open={changeHiringFlowPopup} onClose={() => { setChangeHiringFlowPopup(false); }}>
        <DialogTitle>Hiring Flow for positions</DialogTitle>
        <DialogContent>
          {HiringFlowList.map((item, index) => {
            return (
              <>
                <Typography key={item.id} sx={{ fontSize: "16px", cursor: "pointer" }} onClick={() => handleSelectHiringFlow(item)}>{item.name}</Typography>
              </>
            )
          })}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseHiringFlow}>Cancel</Button>
        </DialogActions>
      </Dialog>

      <TextViewEditorBox></TextViewEditorBox>
      {/* </DashboardLayout> */}
    </>
  );
}
export default CurrentOpenings;
